import { RootState } from "../../../system/redux/store/community-finder-redux-store";

export const selectTotalCommunityCount = (state: RootState) =>
    state?.results?.totalCommunityCount;
